import 'bootstrap'
import '../sass/index.scss'

import { reduce, set, toNumber } from 'lodash'

import { setNavBarActiveLink } from './header'
import { fetchPlaces } from './helpers/api'
import { displayPlaceItem as horizontalCard } from './components/card-horizontal-place'
import { displayPlaceItem as squareCard } from './components/card-square-place'
import { suggestAlternativesWhenNoResults } from './components/empty-results'
import { useSquareCard, fullScreenFilters, getRequestParamsFromURLParams, resetRequestParams, updateURL, handleNearMeParam } from './helpers/helpers'

import { COLLECTIONS } from './helpers/constants'
import Search from './components/search'
import GMaps from './components/gmaps'

/** @type Search */
let search
/** @type GMaps */
let map
const placesRequestParams = {
  status: 'published',
  page_size: 20,
  page: 1,
  order_by: 'clients'
}
let totalPages = 0

function subscribeToPaginationButtons () {
  document.getElementById('places-pagination-prev').addEventListener('click', onPrevPage)
  document.getElementById('places-pagination-next').addEventListener('click', onNextPage)
}

function onPrevPage () {
  placesRequestParams.page -= 1
  populatePlaces({ newPage: true })
  window.parent.scrollTo(0, 0)
}

function onNextPage () {
  placesRequestParams.page += 1
  populatePlaces({ newPage: true })
  window.parent.scrollTo(0, 0)
}

function togglePaginationButtons (previous, next) {
  const prevButton = document.getElementById('places-pagination-prev')
  const nextButton = document.getElementById('places-pagination-next')

  prevButton.disabled = Boolean(!previous)
  nextButton.disabled = Boolean(!next)

  document.getElementById('places-pagination-page-num').textContent = `Página ${placesRequestParams.page} de ${totalPages}`
}

async function populatePlacesList (options) {
  const placesList = document.getElementById('places-list')
  const params = reduce(await getRequestParamsFromURLParams(COLLECTIONS.PLACES, map.gMap, { addMapBounds: options?.addMapBounds }), (acc, value, key) => {
    if (value) { set(acc, key, value) }
    return acc
  }, placesRequestParams)
  const places = await fetchPlaces(params)
  totalPages = Math.ceil(places.count / placesRequestParams.page_size)
  togglePaginationButtons(places.previous, places.next)

  if (!places.results.length) {
    placesList.innerHTML = ''
    placesList.classList.add('empty-results')
    await suggestAlternativesWhenNoResults()
  } else {
    placesList.innerHTML = ''
    placesList.classList.remove('empty-results')
    places.results.forEach((place) => {
      placesList.insertAdjacentHTML('beforeend', useSquareCard() ? squareCard(place) : horizontalCard(place))
    })
  }
}

async function populatePlaces (options) {
  const _populatePlaces = async () => {
    const queryParams = new URLSearchParams(window.location.search)
    const latitude = queryParams.get('latitude')
    const longitude = queryParams.get('longitude')
    const hasLocation = Boolean(latitude && longitude)

    if (hasLocation) { // When searching with location on the map needs to be moved BEFORE any search occurs
      map.move(GMaps.MOVE_TO.COORDS, {
        lat: toNumber(latitude),
        lng: toNumber(longitude)
      })
    }
    document.addEventListener(GMaps.EVENT.ITEMS_ADDED, async () => {
      console.log('PLACES ADDED')
      populatePlacesList({ addMapBounds: true })
    })

    populatePlacesList()

    if (!options?.newPage) {
      map.populate(hasLocation)
    } else if (map.changePage(placesRequestParams)) {
      map.populate(hasLocation, true)
    }
  }

  const placesList = document.getElementById('places-list')
  placesList.textContent = ''
  placesList.insertAdjacentHTML('beforeend', '<div class="preloader"></div>')

  if (options?.initial) {
    document.addEventListener(GMaps.EVENT.BOUNDS_CHANGE, async () => {
      await _populatePlaces()
    })
  } else {
    await _populatePlaces()
  }
}

async function initializeFilters () {
  if (fullScreenFilters()) {
    const filtersContainer = document.getElementById('places-filters')
    filtersContainer.classList.add('full-screen-filters')

    document.getElementById('filters-button').addEventListener('click', () => {
      filtersContainer.classList.toggle('show')
    })

    document.getElementById('close-filters').addEventListener('click', () => {
      filtersContainer.classList.toggle('show')
    })
  }

  document.addEventListener(Search.EVENT.UPDATE, async (event) => {
    resetRequestParams(COLLECTIONS.PLACES, placesRequestParams)
    const updated = updateURL(COLLECTIONS.PLACES, event.detail)

    if (updated) {
      await populatePlaces()
    }
  })

  document.getElementById('clean-filters').addEventListener('click', () => { search.debouncedClean() })
  search = new Search({ auto: true, filters: ['ages', 'categories', 'map', 'attributes'], collection: COLLECTIONS.PLACES })

  return search.init()
}

async function initializeMap () {
  const mapButton = document.getElementById('map-button')
  mapButton.addEventListener('click', () => { map.show() })
  document.addEventListener(GMaps.EVENT.LOADING, () => { mapButton.disabled = true })
  document.addEventListener(GMaps.EVENT.LOADED, () => { mapButton.disabled = false })

  map = new GMaps({ collection: COLLECTIONS.PLACES })
  return map.init()
}

document.addEventListener('DOMContentLoaded', async () => {
  setNavBarActiveLink()
  handleNearMeParam()
  subscribeToPaginationButtons()
  await initializeFilters()
  await initializeMap()
  populatePlaces({ initial: true })
})
